(function () {
  function initPricePerLabel() {
    const dataEl = document.querySelector('[data-price-per-label-json]');
    if (!dataEl) return;

    let variants = [];
    let labels = {};
    try {
      const data = JSON.parse(dataEl.textContent || '{}');
      variants = data.variants || [];
      labels = data.labels || {};
    } catch (e) {
      console.error('PricePerLabel JSON parse failed', e);
      return;
    }

    function getOrCreateHook() {
      let hook = document.querySelector('[data-price-per-label-hook]');
      if (!hook) {
        hook = document.createElement('div');
        hook.className = 'price-per-label-hook';
        hook.setAttribute('data-price-per-label-hook', '');

        const text = document.createElement('span');
        text.className = 'price-per-label-text notranslate';
        text.setAttribute('data-price-per-label-text', '');

        hook.appendChild(text);
      }
      return hook;
    }

    function normalizeText(str) {
      return (str || '')
        .toString()
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    function isQuantityText(text) {
      const txt = normalizeText(text);
      return (
        txt.includes('quantity') ||
        txt.includes('menge') ||
        txt.includes('anzahl') ||
        txt.includes('stückzahl')
      );
    }

    function isColorText(text) {
      const txt = normalizeText(text);
      return (
        txt.includes('color') ||
        txt.includes('colour') ||
        txt.includes('farbe')
      );
    }

    function formatPrice(price) {
      const currency = labels.currency || '€';
      return price.toFixed(2).replace('.', ',') + ' ' + currency;
    }

    function findQuantityFieldset() {
      return document.querySelector(
        '.product-form__input[data-option-slug="menge"], .product-form__input[data-option-slug="quantity"]'
      );
    }

    function getSelectedOptionsFromFieldsets() {
      const result = {};

      document.querySelectorAll('.product-form__input').forEach((wrap) => {
        const slug = normalizeText(wrap.getAttribute('data-option-slug') || '');
        const labelEl = wrap.querySelector('.form__label');
        const labelText = normalizeText(labelEl ? labelEl.textContent : '');

        let selectedValue = '';

        const medium = wrap.querySelector('.form__label .font-medium');
        if (medium) selectedValue = medium.textContent.trim();

        if (!selectedValue) {
          const checkedInput = wrap.querySelector('input:checked');
          if (checkedInput) selectedValue = checkedInput.value || '';
        }

        if (!selectedValue) return;

        if (slug === 'farbe' || slug === 'color' || isColorText(labelText)) {
          result.color = selectedValue;
        }

        if (slug === 'menge' || slug === 'quantity' || isQuantityText(labelText)) {
          result.quantity = selectedValue;
        }
      });

      return result;
    }

    function getCurrentVariantId() {
      const selectedVariantJson = document.querySelector('[data-selected-variant]');
      if (selectedVariantJson) {
        try {
          const currentVariant = JSON.parse(selectedVariantJson.textContent || '{}');
          if (currentVariant && currentVariant.id) return String(currentVariant.id);
        } catch (e) {}
      }

      const candidates = document.querySelectorAll('input[name="id"], select[name="id"]');
      for (const el of candidates) {
        if (el.value) return String(el.value);
      }
      return null;
    }

    function findMatchingVariant(selected) {
      if (selected && Object.keys(selected).length > 0) {
        const matched = variants.find((variant) => {
          const options = [variant.option1, variant.option2, variant.option3]
            .filter(Boolean)
            .map((v) => String(v).trim());

          const colorOk = !selected.color || options.includes(selected.color);
          const quantityOk = !selected.quantity || options.includes(selected.quantity);

          return colorOk && quantityOk;
        });

        if (matched) return matched;
      }

      const currentVariantId = getCurrentVariantId();
      if (currentVariantId) {
        return variants.find((variant) => String(variant.id) === currentVariantId) || null;
      }

      return null;
    }

    function placeHookInQuantityFieldset(hook, fieldset) {
      if (!fieldset) return false;

      const labelRow = fieldset.querySelector('.form__label');
      const swatches = fieldset.querySelector('.swatches');

      if (labelRow && swatches) {
        if (hook.parentNode !== fieldset || hook.nextElementSibling !== swatches) {
          fieldset.insertBefore(hook, swatches);
        }
        return true;
      }

      if (labelRow) {
        if (hook.previousElementSibling !== labelRow) {
          labelRow.insertAdjacentElement('afterend', hook);
        }
        return true;
      }

      return false;
    }

    function updatePricePerLabel() {
      const hook = getOrCreateHook();
      const textEl = hook.querySelector('[data-price-per-label-text]');
      if (!textEl) return;

      const quantityFieldset = findQuantityFieldset();
      const selected = getSelectedOptionsFromFieldsets();
      const variant = findMatchingVariant(selected);

      if (!quantityFieldset || !variant) {
        hook.hidden = true;
        return;
      }

      const price = Number(variant.price || 0);
      const sheetCount = Number(variant.sheet_count || 0);

      if (!price || !sheetCount) {
        hook.hidden = true;
        return;
      }

      const raw = price / 100 / sheetCount;
      const perLabel = Math.floor(raw * 100) / 100;

      const onlyLabel = labels.only || 'Nur';
      const perLabelText = labels.per_label || 'pro Etikett';
      textEl.textContent = `(${onlyLabel} ${formatPrice(perLabel)} ${perLabelText})`;

      placeHookInQuantityFieldset(hook, quantityFieldset);
      hook.hidden = false;
    }

    function runRetries() {
      updatePricePerLabel();
      setTimeout(updatePricePerLabel, 200);
      setTimeout(updatePricePerLabel, 500);
      setTimeout(updatePricePerLabel, 1000);
      setTimeout(updatePricePerLabel, 1800);
    }

    runRetries();

    document.addEventListener(
      'change',
      function () {
        runRetries();
      },
      true
    );

    document.addEventListener(
      'click',
      function () {
        runRetries();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPricePerLabel);
  } else {
    initPricePerLabel();
  }
})();
